module.exports = __webpack_public_path__ + "img/ImgApolo.6e2429d0.png";